import React from "react";
import './get-started.css'

function GetStarted() {
   return(
       <div className="get-started-content text-align-center white-color">
          <div className="text-uppercase font-14 get-started-title margin-b-40">Get Started</div>
          <div className="title-font margin-b-50">Create your first Flo in few seconds</div>
          <div className="btn get-started-btn round-corner font-16">Get started now</div>
       </div>
   )
}

export default GetStarted;
